let sharedContext = null;

function getAudioContext() {
  if (typeof window === 'undefined') {
    return null;
  }

  const AudioCtx = window.AudioContext || window.webkitAudioContext;
  if (!AudioCtx) {
    return null;
  }

  if (!sharedContext) {
    sharedContext = new AudioCtx();
  }

  return sharedContext;
}

function playTone(ctx, { frequency, startTime, duration = 0.12, gain = 0.16, type = 'sine' }) {
  const oscillator = ctx.createOscillator();
  const gainNode = ctx.createGain();

  oscillator.type = type;
  oscillator.frequency.setValueAtTime(frequency, startTime);

  gainNode.gain.setValueAtTime(0, startTime);
  gainNode.gain.linearRampToValueAtTime(gain, startTime + 0.012);
  gainNode.gain.exponentialRampToValueAtTime(0.0001, startTime + duration);

  oscillator.connect(gainNode);
  gainNode.connect(ctx.destination);
  oscillator.start(startTime);
  oscillator.stop(startTime + duration + 0.03);
}

/** Short themed chime for scheduler status transitions. */
export async function playSchedulerNotificationSound(type) {
  const ctx = getAudioContext();
  if (!ctx) {
    return;
  }

  try {
    if (ctx.state === 'suspended') {
      await ctx.resume();
    }

    const now = ctx.currentTime;

    if (type === 'started') {
      playTone(ctx, { frequency: 587.33, startTime: now, duration: 0.1 });
      playTone(ctx, { frequency: 739.99, startTime: now + 0.11, duration: 0.14 });
      return;
    }

    if (type === 'waiting') {
      playTone(ctx, { frequency: 523.25, startTime: now, duration: 0.15 });
      playTone(ctx, { frequency: 659.25, startTime: now + 0.17, duration: 0.18, gain: 0.13 });
      return;
    }

    playTone(ctx, { frequency: 440, startTime: now, duration: 0.16, gain: 0.13 });
    playTone(ctx, { frequency: 349.23, startTime: now + 0.18, duration: 0.2, gain: 0.11 });
  } catch {
    // Ignore autoplay or audio API failures.
  }
}

/** Call after a user gesture so later notifications can play sound reliably. */
export function primeSchedulerNotificationSound() {
  const ctx = getAudioContext();
  if (!ctx) {
    return;
  }

  if (ctx.state === 'suspended') {
    ctx.resume().catch(() => {});
  }
}
